module.exports = __webpack_public_path__ + "static/media/1.cfd2f98b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1.jpg
// module id = 519
// module chunks = 0